import * as core from '../../../../../../../core'
import * as girlsInc from '../girls-inc'

export const RESOURCE = {
  payload: {
    alias: 'details',
    appAlias: girlsInc.RESOURCE.payload.alias,
    description:
      'Shows details about a performance assessment for a given Girls Inc. Affiliate.',
    display: {
      isMain: false,
      position: 2,
    },
    name: 'Details',
    page: { alias: 'details' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
